import React, { useCallback, useEffect, useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Avatar from '@material-ui/core/Avatar';
import Collapse from '@material-ui/core/Collapse';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects';
import SchoolIcon from '@material-ui/icons/School';
import SharedUserDrawer, { DRAWER_WIDTH_LG, DRAWER_WIDTH_XL } from './SharedUserDrawer';
import logo5 from "../logo5.png"
import { useSelector, useDispatch } from "react-redux"
import { Button } from '@material-ui/core';
import * as AuthActions from "../../store/actions/auth";
import Auth from "../../Landingpagecomponents/Header/auth";
import { withRouter, useHistory } from "react-router-dom";
import Yourdiagnosis from './data/Yourdiagnosis';
import Prognosis from "./data/Prognosis";
import Treatmentadvices from "./data/treatmentadvice/Treatmentadvice";
import Recovery_phases from './data/recoveryPhases';
import BodyMapOverlay from './data/BodyMapOverlay';
import { sharedTypographyStyles, FONT_SIZE_CARD_HEADER, FONT_SIZE_SECTION_HEADER, FONT_SIZE_SECTION_TEXT, FONT_SIZE_SUB_TEXT } from './data/sharedStyles';
import { withStyles } from "@material-ui/core/styles";
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { PatientHeaderContent } from "../../Landingpagecomponents/Header/headerPatient";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright � '}
      <Link color="inherit" href="https://material-ui.com/">
        Virtus Physio | Your Virtual Physiotherapist
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

// TabPanel component for managing tab content
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          {children}
        </Box>
      )}
    </div>
  );
}

// WhatToExpectSection component for expandable content
const useWhatToExpectStyles = makeStyles(() => ({
  drawerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    userSelect: 'none',
    padding: 'clamp(12px, 0.75vw, 12px) clamp(12px, 1.05vw, 16px)',
    minHeight: 'clamp(42px, calc(24px + 1.45vw), 56px)',
    backgroundColor: '#FFFFFF',
    borderRadius: 14,
    border: '1px solid #dce9f4',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#e8f0f9',
    },
  },
  drawerArrow: {
    marginLeft: 'clamp(8px, 0.7vw, 12px)',
    fontSize: 'clamp(14px, 1.15vw, 18px)',
    transition: 'transform 0.2s ease',
    display: 'inline-block',
  },
  drawerCard: {
    background: 'linear-gradient(90deg, #dce4eb, #d7d4cf)',
    borderRadius: '0 0 14px 14px',
    boxShadow: '0 2px 12px rgba(106,140,175,0.07)',
    padding: 16,
    marginTop: 0,
    color: '#002D55',
    lineHeight: 1.6,
    fontSize: FONT_SIZE_SECTION_TEXT,
  },
}));

function WhatToExpectSection(props) {
  const { label, content, isOpen, onToggle } = props;
  const classes = useWhatToExpectStyles();

  return (
    <Box style={{ marginBottom: 12 }}>
      <div
        className={classes.drawerRow}
        style={{ borderRadius: isOpen ? '14px 14px 0 0' : 14 }}
        role="button"
        tabIndex={0}
        onClick={onToggle}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onToggle();
          }
        }}
      >
        <Typography style={{ color: '#002D55', fontWeight: 600, fontSize: FONT_SIZE_SECTION_HEADER, margin: 0, lineHeight: 1.2 }}>
          {label}
        </Typography>
        <span className={classes.drawerArrow} style={{ color: isOpen ? '#FF7F27' : '#002D55', transform: isOpen ? 'rotate(0deg)' : 'rotate(-90deg)' }}>
          {isOpen ? '?' : '?'}
        </span>
      </div>
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <Box className={classes.drawerCard}>
          {content}
        </Box>
      </Collapse>
    </Box>
  );
}

const GetJournalButton = withStyles({
  root: {
    boxShadow: "none",
    textTransform: "none",
    fontSize: 15,
    padding: "15px 10px",
    border: "0.5px solid",
    lineHeight: 0.5,
    backgroundColor: "#002D55",
    borderColor: "#002D55",
    color: "#FFFFFF",
    "&:hover": {
        boxShadow: "none",
        backgroundColor: "#0062cc",
        borderColor: "#0062cc"
    },
    //"&:active": {
    //  boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
    //  backgroundColor: "#002D55",
    //  borderColor: "#002D55"
    //},
    //"&:focus": {
    //  boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)"
    //}
  }
})(Button);
//logout
  //
  //

const drawerWidth = 178;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24,
    minHeight: '50px !important',
    maxHeight: 50,
    [theme.breakpoints.up('xl')]: {
      minHeight: '57px !important',
      maxHeight: 57,
    },
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    height: 50,
    maxHeight: 50,
    boxShadow: '0 2px 4px rgba(40,40,40,0.22), 0 2px 6px rgba(40,40,40,0.28)',
    [theme.breakpoints.up('xl')]: {
      height: 57,
      maxHeight: 57,
    },
  },
  responsiveLogo: {
    marginTop: 2,
    maxWidth: 200,
    minWidth: 165,
    [theme.breakpoints.down('xs')]: {
      maxWidth: 120,
      minWidth: 165,
    },
    [theme.breakpoints.up('sm')]: {
      maxWidth: 200,
      minWidth: 165,
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: 200,
      minWidth: 165,
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: 250,
      minWidth: 165,
    },
    [theme.breakpoints.up('xl')]: {
      maxWidth: 250,
      minWidth: 165,
    },
  },
  appBarShift: {
    marginLeft: DRAWER_WIDTH_LG,
    width: `calc(100% - ${DRAWER_WIDTH_LG}px)`,
    [theme.breakpoints.up('xl')]: {
      marginLeft: DRAWER_WIDTH_XL,
      width: `calc(100% - ${DRAWER_WIDTH_XL}px)`,
    },
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 0,
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  containerEmbedded: {
    paddingTop: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 'auto',
  },
  headline: {
    color: '#002D55',
    fontSize: 'clamp(1rem, 1.2vw, 1.6rem)',
  },
  subheadline: {
    color: '#324158',
    fontSize: 'clamp(0.75rem, 0.9vw, 1.12rem)',
  },
  tabsRoot: {
    backgroundColor: '#f7faff',
    borderRadius: 12,
    marginBottom: theme.spacing(1),
    height: 'clamp(34px, calc(4px + 4.5vw), 44px)',
    overflow: 'hidden',
    boxShadow: '0 4px 16px rgba(0,45,85,0.12)',
  },
  tabsControlRoot: {
    minHeight: 'clamp(34px, calc(4px + 4.5vw), 44px)',
    height: 'clamp(34px, calc(4px + 4.5vw), 44px)',
    '& .MuiTabs-flexContainer': {
      height: '100%',
      alignItems: 'center',
    },
  },
  tabRoot: {
    fontWeight: 600,
    fontSize: 'clamp(0.75rem, 1.04vw, 0.95rem)',
    textTransform: 'none',
    color: '#002D55',
    minHeight: 'clamp(24px, calc(4px + 4.5vw), 34px)',
    height: 'clamp(24px, calc(4px + 4.5vw), 34px)',
    minWidth: 'clamp(60px, 6.9vw, 100px)',
    padding: '0 clamp(4px, 0.7vw, 12px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    '&.Mui-selected': {
      color: '#002D55',
    },
    '&:hover': {
      color: '#FF7F27',
    },
  },
  tabCardHeaderRoot: {
    alignItems: 'center',
  },
  tabCardHeaderTitle: {
    color: '#002D55',
    fontWeight: 'bold',
    fontSize: FONT_SIZE_CARD_HEADER,
    display: 'flex',
    alignItems: 'center',
  },
  tabCardHeaderIcon: {
    fontSize: 'clamp(1.05rem, 1.2vw, 1.3rem)',
    marginRight: 'clamp(8px, 0.7vw, 12px)',
    lineHeight: 1,
    display: 'inline-flex',
    alignItems: 'center',
  },
  tabCardHeaderAvatar: {
    backgroundColor: '#6a8caf',
    height: 'clamp(20px, 2.2vw, 36px)',
    width: 'clamp(20px, 2.2vw, 36px)',
  },
  tabCardHeaderAvatarIcon: {
    color: '#fff',
    fontSize: 'clamp(14px, 1.4vw, 22px)',
  },
  ...sharedTypographyStyles,
}));

export default function LearnAboutYourPain() {
  const [isLoggedIn, setIsLoggedIn] = useState(useSelector(state => state.auth.isLoggedIn))
  const [isLoading, setIsLoading] = useState(false)

  const [token, _] = useState(useSelector(state => state.auth.token))
  const embeddedWorkspace = typeof window !== 'undefined'
    && new URLSearchParams(window.location.search).get('embedded') === '1';

  const [activeTab, setActiveTab] = useState(0);
  const [openDrawerIndex, setOpenDrawerIndex] = useState(0); // First drawer open by default
  const [phaseIndex, setPhaseIndex] = useState(null);

  const [diagnosis, setDiagnosis] = useState({
    title: "",
    identifier: "",
    explainer: "",
    indication_for_physiotherapy: ""
  })

  const [prognosis, setPrognosis] = useState({
    Expected_outcome: "",
    Typical_character_Symptoms: "",
    Expected_average_duration: "",
    Expected_development: "",
    If_your_symptoms_worsens: ""
  })

  const [selectedTreatmentId, setSelectedTreatmentId] = useState(null);
  const [treatments, setTreatments] = useState([]);
  const [symptomLocations, setSymptomLocations] = useState({});
  const [journalSections, setJournalSections] = useState(null);

  const user = useSelector(state => state.auth.user);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const dispatch = useDispatch();
  const history = useHistory();

  const handleClickLogout = async () => { 
    console.log('[LOGOUT_HANDLER] handleClickLogout called');
    try {
      console.log('[LOGOUT_HANDLER] Dispatching logout action...');
      await dispatch(AuthActions.logout());
      console.log('[LOGOUT_HANDLER] Logout action completed, redirecting...');
    } catch (e) {
      console.error('[LOGOUT_HANDLER] Error during logout:', e);
      dispatch({type: AuthActions.LOGOUT});
    }
    console.log('[LOGOUT_HANDLER] Redirecting to home...');
    window.location.replace("/");
  };
//virker ovenst�ende som forventet?



  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const handleDrawerOpen = () => setOpen(true);
  const handleDrawerClose = () => setOpen(false);

  const downloadFileTemp = async () => {
    console.log("Downloading")
    console.log(diagnosis)

    setIsLoading(true)
    const response = await fetch(`https://api.virtus-one.com/journal/detailed_pdf/${diagnosis.identifier}`, { 
      headers: {
        "Authorization": `Token ${token}`
      },
      method: "GET",
    }).then((response) => response.blob())
    .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "filename.pdf");
        document.body.appendChild(link);
        link.click();
    });
  };

  useEffect(() => {
    const fetchTreatments = async () => {
      if (!token) return;
      try {
        const res = await fetch('https://api.virtus-one.com/treatment/user/treatments/', {
          headers: { 'Authorization': `Token ${token}` },
          method: 'GET',
        });
        if (res.ok) {
          const data = await res.json();
          setTreatments(data);
          const saved = localStorage.getItem('vp_selectedTreatmentId');
          const defaultTreatment = saved && data.find(t => t.id === saved) ? saved : (data[0]?.id || null);
          setSelectedTreatmentId(defaultTreatment);
        }
      } catch (err) {
        console.error('Failed to fetch treatments', err);
      }
    };
    fetchTreatments();
  }, [token]);

  const fetchDiagnosisData = async (treatmentId, authToken) => {
    if (!treatmentId || !authToken) {
      console.log('[Learn_about_pain] Missing treatmentId or token', { treatmentId, authToken });
      return;
    }
    
    console.log('[Learn_about_pain] Fetching diagnosis for treatmentId:', treatmentId);
    setIsLoading(true);
    try {
      const url = `https://api.virtus-one.com/treatment/phase/progress/treatment/${treatmentId}/`;
      console.log('[Learn_about_pain] Fetching from:', url);
      const response = await fetch(url, {
        headers: { "Authorization": `Token ${authToken}` },
        method: "GET",
      });
      
      console.log('[Learn_about_pain] Response status:', response.status);
      if (response.ok) {
        const data = await response.json();
        console.log('[Learn_about_pain] Received data:', data);
        setDiagnosis({
          title: data.diagnosis_title || "",
          identifier: data.diagnosis_identifier || "",
          explainer: data.diagnosis_explainer || "",
          indication_for_physiotherapy: data.indication_for_physiotherapy || ""
        });
        setPhaseIndex(data.phaseIndex ?? null);
        setPrognosis({
          Expected_outcome: data.prognosis?.Expected_outcome || "",
          Typical_character_Symptoms: data.prognosis?.Typical_character_Symptoms || "",
          Expected_average_duration: data.prognosis?.Expected_average_duration || "",
          Expected_development: data.prognosis?.Expected_development || "",
          If_your_symptoms_worsens: data.prognosis?.If_your_symptoms_worsens || "",
          references: data.prognosis?.references || []
        });
      } else {
        const errorText = await response.text();
        console.error('[Learn_about_pain] ERROR fetching diagnosis data:', response.status, errorText);
        alert("ERROR fetching diagnosis data: " + response.status);
      }
    } catch (err) {
      console.error('[Learn_about_pain] Failed to fetch diagnosis', err);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (selectedTreatmentId && token) {
      fetchDiagnosisData(selectedTreatmentId, token);
    }
  }, [selectedTreatmentId, token])

  // Fetch assessment baseline answers for symptom location annotations
  useEffect(() => {
    if (!diagnosis.identifier || !token || diagnosis.identifier === 'None_Diagnosis') return;
    const controller = new AbortController();
    (async () => {
      try {
        const res = await fetch(
          `https://api.virtus-one.com/assessment/baseline/${encodeURIComponent(diagnosis.identifier)}/?qtypes=multipleChoice,pictureChoice`,
          { headers: { 'Authorization': `Token ${token}` }, signal: controller.signal }
        );
        if (!res.ok) return;
        const data = await res.json();
        const locations = {};
        Object.values(data.baselines || {}).forEach(group => {
          (group.items || []).forEach(item => {
            if (item.question_identifier && item.answerId) {
              locations[item.question_identifier] = item.answerId;
            }
          });
        });
        setSymptomLocations(locations);
      } catch (err) {
        if (err.name !== 'AbortError') console.error('[Learn_about_pain] Failed to fetch symptom locations', err);
      }
    })();
    return () => controller.abort();
  }, [diagnosis.identifier, token]);

  const fetchJournalSections = useCallback(async (signal) => {
    const userId = user && (user.id || user.user_id || user.userId || user.uuid);
    if (!userId || !token || !selectedTreatmentId) return;

    try {
      const params = new URLSearchParams();
      params.set('treatment_id', selectedTreatmentId);
      params.set('_ts', Date.now().toString());
      const latestRes = await fetch(
        `https://api.virtus-one.com/journal/latest/${userId}/?${params.toString()}`,
        {
          headers: { 'Authorization': `Token ${token}`, 'Accept': 'application/json' },
          signal,
          cache: 'no-store'
        }
      );
      if (!latestRes.ok) return;
      const latestData = await latestRes.json();
      if (!latestData || !latestData.assessment_id) return;

      const journalParams = new URLSearchParams();
      journalParams.set('_ts', Date.now().toString());
      const journalRes = await fetch(
        `https://api.virtus-one.com/journal/${latestData.assessment_id}/?${journalParams.toString()}`,
        {
          headers: { 'Authorization': `Token ${token}`, 'Accept': 'application/json' },
          signal,
          cache: 'no-store'
        }
      );
      if (!journalRes.ok) return;
      const journalData = await journalRes.json();
      if (journalData && journalData.sections) {
        setJournalSections(journalData.sections);
      }
    } catch (err) {
      if (err.name !== 'AbortError') console.error('[Learn_about_pain] Failed to fetch journal sections', err);
    }
  }, [selectedTreatmentId, token, user]);

  // Fetch journal sections (same data shown in staff assessment view)
  useEffect(() => {
    const controller = new AbortController();
    fetchJournalSections(controller.signal);
    return () => controller.abort();
  }, [fetchJournalSections]);

  // Keep prognosis in sync with the latest journal version.
  useEffect(() => {
    const userId = user && (user.id || user.user_id || user.userId || user.uuid);
    if (!userId || !token || !selectedTreatmentId) return undefined;

    const shouldRefresh = (detail) => {
      if (!detail) return true;
      if (detail.userId && String(detail.userId) !== String(userId)) return false;
      if (detail.treatmentId && String(detail.treatmentId) !== String(selectedTreatmentId)) return false;
      return true;
    };

    const refreshJournal = (detail) => {
      if (!shouldRefresh(detail)) return;
      fetchJournalSections();
    };

    const handleJournalUpdated = (event) => {
      refreshJournal(event && event.detail ? event.detail : null);
    };
    const handleStorage = (event) => {
      if (!event || event.key !== 'vp_latest_journal_update' || !event.newValue) return;
      try {
        refreshJournal(JSON.parse(event.newValue));
      } catch (err) {
        refreshJournal(null);
      }
    };
    const handleFocus = () => {
      refreshJournal(null);
    };
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') refreshJournal(null);
    };
    const intervalId = window.setInterval(() => {
      if (document.visibilityState === 'visible') refreshJournal(null);
    }, 30000);

    window.addEventListener('vp-journal-updated', handleJournalUpdated);
    window.addEventListener('storage', handleStorage);
    window.addEventListener('focus', handleFocus);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      window.removeEventListener('vp-journal-updated', handleJournalUpdated);
      window.removeEventListener('storage', handleStorage);
      window.removeEventListener('focus', handleFocus);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.clearInterval(intervalId);
    };
  }, [fetchJournalSections, selectedTreatmentId, token, user]);

  
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
  
  // Security check: verify authentication before rendering
  if (!isLoggedIn || !token) {
    window.location.replace("/");
    return <div>Redirecting...</div>;
  }
  
  if (isLoggedIn) {
    return (
      <div className={classes.root}>
        <CssBaseline />
        {!embeddedWorkspace ? (
          <>
            <AppBar style={{ color: "#002D55", backgroundColor: "#FFFFFF" }} position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
              <Toolbar className={classes.toolbar}>
                <PatientHeaderContent 
                  onLogout={handleClickLogout} 
                  onProfile={() => history.push('/myaccount?tab=profile')} 
                  onOpenVideo={() => {}} 
                  onOpenCheckin={() => {}} 
                  onTreatmentChange={(treatment) => {
                    setSelectedTreatmentId(treatment.id);
                  }}
                />
              </Toolbar>
            </AppBar>
            <SharedUserDrawer open={open} onOpen={handleDrawerOpen} onClose={handleDrawerClose} />
          </>
        ) : null}
        <main className={classes.content} style={{background: 'linear-gradient(90deg, #dce4eb, #d7d4cf)'}}>
          {!embeddedWorkspace ? <div className={classes.appBarSpacer} /> : null}
          <Container key={selectedTreatmentId} maxWidth="100%" className={clsx(classes.container, embeddedWorkspace && classes.containerEmbedded)}>
            <Grid item xs={12} >
              <Box>
                <div className={classes.tabsRoot}>
                <Tabs 
                  value={activeTab} 
                  onChange={(event, newValue) => setActiveTab(newValue)}
                  TabIndicatorProps={{ style: { backgroundColor: '#FF7F27', height: 3, borderRadius: 18 } }}
                  textColor="inherit"
                  classes={{ root: classes.tabsControlRoot }}
                >
                  <Tab 
                    label="Your Symptoms" 
                    id="tab-0"
                    aria-controls="tabpanel-0"
                    classes={{ root: classes.tabRoot }}
                  />
                  <Tab 
                    label="What To Expect" 
                    id="tab-1"
                    aria-controls="tabpanel-1"
                    classes={{ root: classes.tabRoot }}
                  />
                  <Tab 
                    label="Advice & Education" 
                    id="tab-2"
                    aria-controls="tabpanel-2"
                    classes={{ root: classes.tabRoot }}
                  />
                  <Tab 
                    label="Recovery Phases" 
                    id="tab-3"
                    aria-controls="tabpanel-3"
                    classes={{ root: classes.tabRoot }}
                  />
                </Tabs>
                </div>
                
                {/* Tab 0: Prognosis Overview */}
                <TabPanel value={activeTab} index={0}>
                  <Prognosis
                    title={diagnosis.title}
                    explainer={diagnosis.explainer} 
                    Expected_outcome={prognosis.Expected_outcome}
                    Typical_character_Symptoms={prognosis.Typical_character_Symptoms}
                    Expected_average_duration={prognosis.Expected_average_duration}
                    Expected_development={prognosis.Expected_development}
                    If_your_symptoms_worsens={prognosis.If_your_symptoms_worsens}
                    references={prognosis.references}
                    treatmentId={selectedTreatmentId}
                    diagnosisIdentifier={diagnosis.identifier}
                    symptomLocations={symptomLocations}
                    journalSections={journalSections}
                    indicationForPhysiotherapy={diagnosis.indication_for_physiotherapy}
                  />
                </TabPanel>

                {/* Tab 1: What To Expect */}
                <TabPanel value={activeTab} index={1}>
                  <Card style={{ background: '#f7faff', borderRadius: 14, boxShadow: '0 6px 32px rgba(0,45,85,0.18)' }}>
                    <CardHeader
                      className={classes.tabCardHeaderRoot}
                      avatar={<Avatar className={classes.tabCardHeaderAvatar}><EmojiObjectsIcon className={classes.tabCardHeaderAvatarIcon} /></Avatar>}
                      title={<span className={classes.tabCardHeaderTitle}>What To Expect</span>}
                      style={{ marginBottom: 5, padding: 10, borderBottom: "2px solid #fb741a", alignItems: 'center' }}
                    />
                    <CardContent style={{ paddingTop: 16 }}>
                      <Box style={{ marginBottom: 16 }}>
                        <Typography style={{ color: '#666', fontSize: FONT_SIZE_SUB_TEXT, lineHeight: 1.6, marginBottom: 26 }}>
                          Click the sections below to learn more about what to expect during your treatment. Understanding what to expect as you progress through your treatment can help you stay motivated and recognize positive changes.
                        </Typography>
                      </Box>
                      
                      {/* Expandable sections */}
                      <Box style={{ marginBottom: 20, maxWidth: 1200}}>
                        <WhatToExpectSection 
                          label="Expected outcome"
                          content={prognosis.Expected_outcome}
                          isOpen={openDrawerIndex === 0}
                          onToggle={() => setOpenDrawerIndex(0)}
                        />
                        <WhatToExpectSection 
                          label="Typical character of symptoms"
                          content={prognosis.Typical_character_Symptoms}
                          isOpen={openDrawerIndex === 1}
                          onToggle={() => setOpenDrawerIndex(1)}
                        />
                        <WhatToExpectSection 
                          label="Expected average duration"
                          content={prognosis.Expected_average_duration}
                          isOpen={openDrawerIndex === 2}
                          onToggle={() => setOpenDrawerIndex(2)}
                        />
                        <WhatToExpectSection 
                          label="Expected development"
                          content={prognosis.Expected_development}
                          isOpen={openDrawerIndex === 3}
                          onToggle={() => setOpenDrawerIndex(3)}
                        />
                      </Box>
                    </CardContent>
                  </Card>
                </TabPanel>

                {/* Tab 2: Advice & Education */}
                <TabPanel value={activeTab} index={2}>
                  <Card style={{ background: '#f7faff', borderRadius: 14, boxShadow: '0 6px 32px rgba(0,45,85,0.18)' }}>
                    <CardHeader
                      className={classes.tabCardHeaderRoot}
                      avatar={<Avatar className={classes.tabCardHeaderAvatar}><SchoolIcon className={classes.tabCardHeaderAvatarIcon} /></Avatar>}
                      title={<span className={classes.tabCardHeaderTitle}>Advice & Education</span>}
                      style={{ marginBottom: 5, padding: 10, borderBottom: "2px solid #fb741a", alignItems: 'center' }}
                    />
                    <CardContent style={{ paddingTop: 16 }}>
                      <Box style={{ marginBottom: 20, maxWidth: 1200}}>
                        <Typography style={{ color: '#666', fontSize: FONT_SIZE_SUB_TEXT, lineHeight: 1.6, marginBottom: 16 }}>
                          In addition to your exercises the following advices can help you control pain and help manage your condition. Here are personalized treatment recommendations and educational resources to support your recovery.
                        </Typography>
                      
                      <Treatmentadvices />
                      </Box>
                    </CardContent>
                  </Card>
                </TabPanel>

                {/* Tab 3: Recovery Phases */}
                <TabPanel value={activeTab} index={3}>
                  <Recovery_phases
                    phaseIndex={phaseIndex}
                    treatmentId={selectedTreatmentId}
                  />
                </TabPanel>
              </Box>
            </Grid>
            
            <Box pt={4}>
              <Copyright />
            </Box>
          </Container>
        </main>
      </div>
    );
  } else {
    return <div>Unauthorized</div>;
  }
}
